<template>
  <b-overlay :show="loading && false" opacity="0.99">
    <ErrorsMessages :errors="errors" />
    <div class="row" v-if="filters">
      <div class="col-md-2" v-if="!entity_id_disabled">
        <label>ENTIDADE</label>
        <input
          type="number"
          v-model="internal_entity_id"
          @input="lazyGetHistory"
          class="form-control"
        />
      </div>
      <div class="col-md-4" v-if="!user_id_disabled">
        <label>USUÁRIO</label>
        <select
          v-model="internal_user_id"
          @change="getHistory"
          class="form-control"
        >
          <option v-for="(user, key) in users" :key="key" :value="user.id">
            {{ String(user.name).toUpperCase() }}
          </option>
        </select>
      </div>
      <div class="col-md-6">
        <label>BUSCAR</label>
        <input
          type="text"
          v-model="search"
          @input="lazyGetHistory"
          class="form-control"
        />
      </div>
    </div>
    <h6 class="text-center" v-if="title && items.length > 0">{{ title }}</h6>
    <div
      class="text-center v-clean p-5"
      v-if="show_text_no_data && items.length == 0"
    >
      <h6 class="text-center upper-text worksansr">Sem resultados!</h6>
    </div>
    <v-data-table
      v-show="items.length > 0"
      class="no-border-table"
      disable-sort
      :headers="headers"
      :items="items"
      dense
      :server-items-length="count"
      :options.sync="options"
      :footer-props="{
        'items-per-page-options': [100],
        'items-per-page-text': 'Mostrar',
      }"
      hide-default-footer
      :loading="loading"
      loading-text="Carregando..."
      no-data-text="Nenhum resultado corresponde aos filtros"
      no-results-text="Nenhum resultado corresponde aos filtros"
      @update:options="evOnUpdateOptions"
    >
      <template v-slot:[`item.user_id`]="{ item }">
        (Assinatura eletrônica)
        {{ getNameByID(item.user_id) }}
      </template>
      <template v-slot:[`item.when`]="{ item }">
        {{ formatDate(item.when) }}
      </template>
      <template v-slot:[`item.action`]="{ item }">
        {{
          {
            created: "CRIOU",
            doubled: "DUPLICOU",
            modified: "MODIFICOU",
            removed: "REMOVEU",
          }[item.action]
        }}
      </template>
      <template v-slot:[`item.entity_then`]="{ item }">
        <div class="row" v-if="item.entity_then">
          <div
            class="col-md-12 p-0"
            v-for="k in Object.keys(item.entity_then)"
            :key="k"
            v-show="item.entity_then[k]"
          >
            {{ handleEntityThen(item, k) }}
          </div>
        </div>
      </template>
      <template v-slot:[`item.entity_now`]="{ item }">
        <div class="row" v-if="item.entity_now">
          <div
            class="col-md-12 p-0"
            v-for="k in Object.keys(item.entity_now)"
            :key="k"
            v-show="item.entity_now[k]"
          >
            {{ handleEntityNow(item, k) }}
          </div>
        </div>
      </template>
    </v-data-table>
  </b-overlay>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";

import { formatDate, professionalClassCouncilValue } from "../../lib/format";

import api from "../../services/api";

export default {
  name: "History",
  components: {
    ErrorsMessages,
  },
  props: {
    show_text_no_data: Boolean,
    filters: Boolean,
    toggle: Boolean,
    title: String,
    table: String,
    user_id: [String, Number],
    entity_id: [String, Number],
    entity_id_disabled: Boolean,
    user_id_disabled: Boolean,
  },
  watch: {
    toggle: function () {
      this.show = true;
    },
    user_id: (value) => (this.internal_user_id = value),
    entity_id: function (value) {
      this.internal_entity_id = value;
      this.evOnShow();
    },
  },
  created() {
    this.evOnShow();
    this.internal_user_id = this.user_id;
    this.internal_entity_id = this.entity_id;
  },
  data() {
    return {
      errors: [],
      show: false,
      loading: false,
      headers: [
        {
          text: "RESPONSÁVEL",
          value: "user_id",
          sortable: false,
        },
        { text: "OCORRÊNCIA", value: "when", sortable: false },
        { text: "AÇÃO", value: "action", sortable: false },
        {
          text: "ANTES",
          value: "entity_then",
          sortable: false,
        },
        {
          text: "DEPOIS",
          value: "entity_now",
          sortable: false,
        },
      ],
      items: [],
      options: {
        page: 1,
        itemsPerPage: 25,
        sortBy: ["when"],
        sortDesc: [true],
        multiSort: true,
        mustSort: false,
      },
      count: 0,
      debouncer: undefined,
      //filtros
      users: [],
      internal_user_id: "",
      internal_entity_id: "",
      search: "",
    };
  },
  methods: {
    formatDate,
    professionalClassCouncilValue,
    handleEntityThen(item, k) {
      let typesDate = ["start_date", "end_date"];
      if (typesDate.includes(k)) {
        return `${item.fields[k]}: ${formatDate(item.entity_then[k], false)}`;
      } else {
        return `${item.fields[k]}: ${item.entity_then[k]}`;
      }
    },
    handleEntityNow(item, k) {
      let typesDate = ["start_date", "end_date"];
      if (typesDate.includes(k)) {
        return `${item.fields[k]}: ${formatDate(item.entity_now[k], false)}`;
      } else {
        return `${item.fields[k]}: ${item.entity_now[k]}`;
      }
    },
    async getUsers() {
      try {
        this.loading = true;

        let response = await api.get("/rest-home/users");
        let { error, errors, users } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.users = users;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getHistory() {
      try {
        this.loading = true;

        let sortings = [];
        for (let i = 0; i < this.options.sortBy.length; i++) {
          let header = this.options.sortBy[i];
          let order = this.options.sortDesc[i] ? "desc" : "asc";
          sortings.push({ header, order });
        }

        sortings = JSON.stringify(sortings);

        let params = {
          table: this.table,
          user_id: this.internal_user_id,
          entity_id: this.internal_entity_id,
          search: this.search,
          page: this.options.page,
          items_per_page: this.options.itemsPerPage,
          sortings,
        };

        if (!this.internal_entity_id) {
          this.items = [];
          this.count = 0;
          this.errors = [];
          return;
        }

        let response = await api.get("/rest-home/history", { params });
        let { error, errors, items, count } = response.data;

        if (error) {
          this.items = [];
          this.count = 0;
          this.errors = errors;
        } else {
          this.errors = [];
          this.items = items;
          this.count = count;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    getNameByID(id) {
      for (let user of this.users) {
        if (user.id == id) {
          return professionalClassCouncilValue({
            id: user.professional_class_council_id,
            name: user.name,
            profile: user.user_profile_name,
            cpf: user.cpf,
            value: user.professional_class_council_value,
            office: user.office,
          });
        }
      }
      return "ADMINISTRADOR";
    },
    async lazyGetHistory() {
      clearTimeout(this.debouncer);
      this.debouncer = setTimeout(this.getHistory, 500);
    },
    async evOnShow() {
      this.search = "";
      this.internal_user_id = this.user_id;
      this.internal_entity_id = this.entity_id;
      await this.getHistory();
      await this.getUsers();
    },
    async evOnHide() {
      this.show = false;
    },
    async evOnUpdateOptions() {
      await this.getHistory();
    },
  },
};
</script>

<style>
</style>